import { memo } from "react";
import "./Stepper.scss";
import PropTypes from "prop-types";
import Step from "./Step";

const Stepper = ({ steps = [], currentStep = 1 }) => {
	return (
		<ol className="stepper">
			{steps.map((stepLabel, index) => {
				const isStepCompleted = index + 1 < currentStep;
				const isCurrentStep = index + 1 === currentStep;

				return (
					<Step
						key={stepLabel}
						label={stepLabel}
						isCompleted={isStepCompleted}
						isCurrent={isCurrentStep}
					/>
				);
			})}
		</ol>
	);
};

Stepper.propTypes = {
	steps: PropTypes.arrayOf(PropTypes.string).isRequired,
	currentStep: PropTypes.number,
};

export default memo(Stepper);
